<template>

	<div id="notfound" >
    <br><br>
		<div class="notfound" style="padding-top: 100px;">

      <img src="../assets/logo.png" alt="" style="padding-top: 200px;width:130px">
            <h1 style="color:#0ea2bd;">MP Guest</h1>
			<p style="font-size:20px; color:gray;">Make a reservation for massage</p><br>
      <p style="font-size:20px; color:#0ea2bd;">Choose location:</p><br>
      <a href="/massage/sp/">      <div class="col-sm-12">
              <div class="card bg-c-tenis order-card" >
    
  
                  <div class="card-block">
                      
                      <span>
            
                          <h2 class="text-right" style="color:white;">Babaloo Beach bar</h2>    
                        
               
                      </span> 
  
                  </div>
              </div>
          </div></a>
          <a href="/massage/paleo/">  
      <div class="col-sm-12" style="padding:15px;">
              <div class="card bg-c-tenis order-card" >
    
  
                  <div class="card-block">
                
                      <span>
            
                          <h2 class="text-right" style="color:white;" >Paleo Park</h2>    
                        
               
                      </span> 
  
                  </div>
              </div>
          </div></a>

      <div>

    
      </div>

      <p style="font-size:20px; color:gray;">Are you a guest?<br> Download the app and get much more</p><br>
        <a href="https://apps.apple.com/us/app/mp-guest/id6446415363"><img src="../assets/apple.png" style="width:250px;"></a><br>
        <a href="https://play.google.com/store/apps/details?id=mpstaff.herokuapp.com"><img src="../assets/googleplay.png" style="width:250px;"></a><br>
		</div>
	</div>


</template>

<script>
export default {
  name: 'Info',
  mounted(){
    var lang = localStorage.getItem('lang')
    if(lang!=null){
       if(lang=='de'){
        $('#de').css('opacity', '0.9');
        $('#gb').css('opacity', '0.5');
      }
      else{
        $('#de').css('opacity', '0.5');
        $('#gb').css('opacity', '0.9');
      }
      this.$i18n.locale=lang;
    } 
  

  },

  
  
}
</script>
<style scoped>

#notfound {
  position: relative;
  height: 100vh;
  background: #f6f6f6;
}

#notfound .notfound {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.notfound {
  max-width: 767px;
  width: 100%;
  line-height: 1.4;
  padding: 110px 40px;
  text-align: center;
  background: #fff;
  -webkit-box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.1);
          box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.1);
}

.notfound .notfound-404 {
  position: relative;
  height: 180px;
}

.notfound .notfound-404 h1 {
  font-family: 'Roboto', sans-serif;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  font-size: 165px;
  font-weight: 700;
  margin: 0px;
  color: #262626;
  text-transform: uppercase;
}

.notfound .notfound-404 h1>span {
  color: #00b7ff;
}

.notfound h2 {
  font-family: 'Roboto', sans-serif;
  font-size: 22px;
  font-weight: 400;

  color: #151515;
  margin-top: 0px;
  margin-bottom: 25px;
}

.notfound .notfound-search {
  position: relative;
  max-width: 320px;
  width: 100%;
  margin: auto;
}

.notfound .notfound-search>input {
  font-family: 'Roboto', sans-serif;
  width: 100%;
  height: 50px;
  padding: 3px 65px 3px 30px;
  color: #151515;
  font-size: 16px;
  background: transparent;
  border: 2px solid #c5c5c5;
  border-radius: 40px;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
}

.notfound .notfound-search>input:focus {
  border-color: #00b7ff;
}

.notfound .notfound-search>button {
  position: absolute;
  right: 15px;
  top: 5px;
  width: 40px;
  height: 40px;
  text-align: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.notfound .notfound-search>button>span {
  width: 15px;
  height: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
      -ms-transform: translate(-50%, -50%) rotate(-45deg);
          transform: translate(-50%, -50%) rotate(-45deg);
  margin-left: -3px;
}


@media only screen and (max-width: 767px) {
  .notfound h2 {
    font-size: 18px;
  }
}

@media only screen and (max-width: 480px) {
  .notfound .notfound-404 h1 {
    font-size: 141px;
  }
}


</style>